export default "__VITE_ASSET__Ct_7aRya__"